module.exports = __webpack_public_path__ + "static/media/FeelDataReportNoData.8cf63b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FeelDataReportNoData.png
// module id = 997
// module chunks = 0